import { BUBBLETAP_TEL, supportEmail } from '@repo/constants';

import * as Styled from '../../policy.styled';

export default function YouthProtectionPolicyZh() {
  const SUPPORT_EMAIL = supportEmail('zh');

  return (
    <Styled.MainWrapper>
      <h3 style={{ marginBottom: '40px' }}>BubbleTap 兒童及少年福利與權益保障法</h3>
      BubbleTap Corp. (以下簡稱「本公司」)
      為協助青少年安全使用網路，實施了韓國《資訊通信網路利用促進及資訊保護法》等相關法律中規定的青少年保護政策。
      <p>第1條 青少年保護之目標與基本原則</p>
      本政策旨在保護青少年免受精神及身體上的有害環境影響，使其能夠健全成長，並透過提供安全的網路服務，明確闡述本公司的青少年保護政策。
      <p>第2條 針對有害青少年資訊的青少年保護及管理措施</p>
      本公司為保護青少年，避免其在無任何限制下接觸有害資訊，已針對可能對青少年造成危害的媒體內容設立並採用年齡驗證機制。因此，對於設有成人驗證機制的服務，我們將限制青少年的使用範圍，以進行管理。此外，本公司亦持續監控及管理非法或對青少年有害的內容。
      <p>第3條 因有害青少年資訊所導致的損害諮詢及申訴處理</p>
      本公司已安排專業人員，以處理因有害資訊所造成的損害諮詢與申訴，防止損害進一步擴大。您也可以參考下列的青少年保護負責人的所屬部門、姓名與聯絡方式，申請損害諮詢與申訴。如果我們難以自行處理，將會為您提供相關機構的資訊。
      <p>第4條 保護青少年免受有害資訊侵害的教育</p>
      本公司針對青少年保護負責人及各項服務的負責人進行教育訓練，內容包含：保護青少年相關法令及制裁標準、發現有害資訊時的應對方法，以及違規事項的處理及通報流程等。
      <p>第5條 青少年保護負責人及專員</p>
      本公司指定了青少年保護負責人與青少年保護專員，致力於營造健康的網路環境，包括阻斷與管理有害青少年的資訊，並建立保護青少年免受有害資訊侵害的政策。
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>職責</th>
              <th>姓名</th>
              <th>隸屬</th>
              <th>職稱</th>
              <th>電話</th>
              <th>聯絡方式</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                青少年保
                <br />
                護負責人
              </td>
              <td>박종범</td>
              <td>BubbleTap Team</td>
              <td>CEO</td>
              <td>
                <span className="tel">{BUBBLETAP_TEL}</span>
              </td>
              <td>{SUPPORT_EMAIL}</td>
            </tr>
            <tr>
              <td>
                青少年保
                <br />
                護負責人
              </td>
              <td>김현호</td>
              <td>BubbleTap Team</td>
              <td>室長</td>
              <td>
                <span className="tel">{BUBBLETAP_TEL}</span>
              </td>
              <td>{SUPPORT_EMAIL}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </Styled.MainWrapper>
  );
}
